import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from './Header.module.css';
import logo from '../../assets/images/logo.png';
import userIcon from '../../assets/images/user-icon.png';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (sectionId) => {
    if (location.pathname === '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        const headerOffset = 80;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    } else {
      navigate(`/#${sectionId}`);
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          const headerOffset = 80;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  };

  const sectionIds = {
    'О нас': 'about',
    'Услуги': 'services', 
    'Кейсы': 'cases',
    'Контакты': 'feedback'
  };

  return (
    <header className={`${styles.header} navbar navbar-expand-lg`}>
      <div className={`container-fluid ${styles.navContainer}`}>
        <a href="/" className={styles.logo}>
          <img src={logo} alt="Логотип" width={250} height={60} />
        </a>
        <button 
          className="navbar-toggler" 
          type="button" 
          data-bs-toggle="collapse" 
          data-bs-target="#navbarContent"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className={`collapse navbar-collapse ${styles.navContent}`} id="navbarContent">
          <div className={styles.navLinksWrapper}>
            <nav className={`navbar-nav ${styles.navLinks}`}>
              {['О нас', 'Услуги', 'Кейсы', 'Контакты'].map((item) => (
                <button 
                  key={item} 
                  onClick={() => scrollToSection(sectionIds[item])}
                  className={`nav-link ${styles.navItem}`}
                  style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                >
                  {item}
                </button>
              ))}
            </nav>
            <div className={styles.userIconWrapper}>
              <a href="/login">
                <img src={userIcon} alt="Личный кабинет" width={40} height={40} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;